// Copyright 2019 Sorama B.V.

import { AxisKind, FrequencyAxisKinds } from "datatypes/SettingsKinds/AxisKinds";
import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import { UnitParser } from "./UnitParser";

export class AxisKindParser implements IWorkflowPropertyParser<AxisKind> {
    toWorkflowProperty(object: AxisKind): string {
        const unitParser = new UnitParser();
        const property = unitParser.toWorkflowProperty(object.unit);

        if (property == undefined) return undefined;

        return object.name + "," + object.shortName + "," + property;
    }

    fromWorkflowProperty(str: string): AxisKind {
        const unitParser = new UnitParser();
        const vals = str.split(",");
        const baseUnit = unitParser.fromWorkflowProperty(vals[2]);

        return FrequencyAxisKinds.find(
            (x) => x.name == vals[0] && x.shortName == vals[1] && x.unit.unit == baseUnit.unit
        );
    }
}
